import { render, staticRenderFns } from "./select-performanse.vue?vue&type=template&id=19277a65&"
import script from "./select-performanse.vue?vue&type=script&lang=js&"
export * from "./select-performanse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports